/**
 *
 * subnav reducer
 *
 */

const initialState = {};

const subnavReducer = (state = initialState) => {

    return state;

};

export default subnavReducer;
